module.exports = __webpack_public_path__ + "static/img/乘坐猴车携带超长物料.c3197682.png";